/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeBotPluginListResponse,
  ApiEnvelopeBotPluginSaveSettingsResponse,
  ApiEnvelopeBotPluginSettingsResponse,
  ApiEnvelopeBotPluginToggleResponse,
  SaveSettingsRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type botPluginListPluginsResponse200 = {
  data: ApiEnvelopeBotPluginListResponse
  status: 200
}

export type botPluginListPluginsResponse401 = {
  data: ApiEnvelopeBotPluginListResponse
  status: 401
}

export type botPluginListPluginsResponse403 = {
  data: ApiEnvelopeBotPluginListResponse
  status: 403
}

export type botPluginListPluginsResponse404 = {
  data: ApiEnvelopeBotPluginListResponse
  status: 404
}

export type botPluginListPluginsResponseSuccess = (botPluginListPluginsResponse200) & {
  headers: Headers;
};
export type botPluginListPluginsResponseError = (botPluginListPluginsResponse401 | botPluginListPluginsResponse403 | botPluginListPluginsResponse404) & {
  headers: Headers;
};

export type botPluginListPluginsResponse = (botPluginListPluginsResponseSuccess | botPluginListPluginsResponseError)

export const getBotPluginListPluginsUrl = (botId: string,) => {




  return `/api/botengine/${botId}/plugins`
}

export const useBotPluginListPluginsHook = (): (botId: string, options?: RequestInit) => Promise<botPluginListPluginsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotPluginListPluginsUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botPluginEnablePluginResponse200 = {
  data: ApiEnvelopeBotPluginToggleResponse
  status: 200
}

export type botPluginEnablePluginResponse400 = {
  data: ApiEnvelopeBotPluginToggleResponse
  status: 400
}

export type botPluginEnablePluginResponse401 = {
  data: ApiEnvelopeBotPluginToggleResponse
  status: 401
}

export type botPluginEnablePluginResponse403 = {
  data: ApiEnvelopeBotPluginToggleResponse
  status: 403
}

export type botPluginEnablePluginResponse404 = {
  data: ApiEnvelopeBotPluginToggleResponse
  status: 404
}

export type botPluginEnablePluginResponseSuccess = (botPluginEnablePluginResponse200) & {
  headers: Headers;
};
export type botPluginEnablePluginResponseError = (botPluginEnablePluginResponse400 | botPluginEnablePluginResponse401 | botPluginEnablePluginResponse403 | botPluginEnablePluginResponse404) & {
  headers: Headers;
};

export type botPluginEnablePluginResponse = (botPluginEnablePluginResponseSuccess | botPluginEnablePluginResponseError)

export const getBotPluginEnablePluginUrl = (botId: string,
    pluginName: string,) => {




  return `/api/botengine/${botId}/plugins/${pluginName}/enable`
}

export const useBotPluginEnablePluginHook = (): (botId: string,
    pluginName: string, options?: RequestInit) => Promise<botPluginEnablePluginResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    pluginName: string, options?: RequestInit) => {

        return customFetcher(getBotPluginEnablePluginUrl(botId,pluginName),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type botPluginDisablePluginResponse200 = {
  data: ApiEnvelopeBotPluginToggleResponse
  status: 200
}

export type botPluginDisablePluginResponse400 = {
  data: ApiEnvelopeBotPluginToggleResponse
  status: 400
}

export type botPluginDisablePluginResponse401 = {
  data: ApiEnvelopeBotPluginToggleResponse
  status: 401
}

export type botPluginDisablePluginResponse403 = {
  data: ApiEnvelopeBotPluginToggleResponse
  status: 403
}

export type botPluginDisablePluginResponse404 = {
  data: ApiEnvelopeBotPluginToggleResponse
  status: 404
}

export type botPluginDisablePluginResponseSuccess = (botPluginDisablePluginResponse200) & {
  headers: Headers;
};
export type botPluginDisablePluginResponseError = (botPluginDisablePluginResponse400 | botPluginDisablePluginResponse401 | botPluginDisablePluginResponse403 | botPluginDisablePluginResponse404) & {
  headers: Headers;
};

export type botPluginDisablePluginResponse = (botPluginDisablePluginResponseSuccess | botPluginDisablePluginResponseError)

export const getBotPluginDisablePluginUrl = (botId: string,
    pluginName: string,) => {




  return `/api/botengine/${botId}/plugins/${pluginName}/disable`
}

export const useBotPluginDisablePluginHook = (): (botId: string,
    pluginName: string, options?: RequestInit) => Promise<botPluginDisablePluginResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    pluginName: string, options?: RequestInit) => {

        return customFetcher(getBotPluginDisablePluginUrl(botId,pluginName),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type botPluginGetPluginSettingsResponse200 = {
  data: ApiEnvelopeBotPluginSettingsResponse
  status: 200
}

export type botPluginGetPluginSettingsResponse401 = {
  data: ApiEnvelopeBotPluginSettingsResponse
  status: 401
}

export type botPluginGetPluginSettingsResponse403 = {
  data: ApiEnvelopeBotPluginSettingsResponse
  status: 403
}

export type botPluginGetPluginSettingsResponse404 = {
  data: ApiEnvelopeBotPluginSettingsResponse
  status: 404
}

export type botPluginGetPluginSettingsResponseSuccess = (botPluginGetPluginSettingsResponse200) & {
  headers: Headers;
};
export type botPluginGetPluginSettingsResponseError = (botPluginGetPluginSettingsResponse401 | botPluginGetPluginSettingsResponse403 | botPluginGetPluginSettingsResponse404) & {
  headers: Headers;
};

export type botPluginGetPluginSettingsResponse = (botPluginGetPluginSettingsResponseSuccess | botPluginGetPluginSettingsResponseError)

export const getBotPluginGetPluginSettingsUrl = (botId: string,) => {




  return `/api/botengine/${botId}/settings`
}

export const useBotPluginGetPluginSettingsHook = (): (botId: string, options?: RequestInit) => Promise<botPluginGetPluginSettingsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotPluginGetPluginSettingsUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botPluginSavePluginSettingsResponse200 = {
  data: ApiEnvelopeBotPluginSaveSettingsResponse
  status: 200
}

export type botPluginSavePluginSettingsResponse401 = {
  data: ApiEnvelopeBotPluginSaveSettingsResponse
  status: 401
}

export type botPluginSavePluginSettingsResponse403 = {
  data: ApiEnvelopeBotPluginSaveSettingsResponse
  status: 403
}

export type botPluginSavePluginSettingsResponse404 = {
  data: ApiEnvelopeBotPluginSaveSettingsResponse
  status: 404
}

export type botPluginSavePluginSettingsResponseSuccess = (botPluginSavePluginSettingsResponse200) & {
  headers: Headers;
};
export type botPluginSavePluginSettingsResponseError = (botPluginSavePluginSettingsResponse401 | botPluginSavePluginSettingsResponse403 | botPluginSavePluginSettingsResponse404) & {
  headers: Headers;
};

export type botPluginSavePluginSettingsResponse = (botPluginSavePluginSettingsResponseSuccess | botPluginSavePluginSettingsResponseError)

export const getBotPluginSavePluginSettingsUrl = (botId: string,
    pluginName: string,) => {




  return `/api/botengine/${botId}/settings/${pluginName}`
}

export const useBotPluginSavePluginSettingsHook = (): (botId: string,
    pluginName: string,
    saveSettingsRequest?: SaveSettingsRequest, options?: RequestInit) => Promise<botPluginSavePluginSettingsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    pluginName: string,
    saveSettingsRequest?: SaveSettingsRequest, options?: RequestInit) => {

        return customFetcher(getBotPluginSavePluginSettingsUrl(botId,pluginName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(saveSettingsRequest)
  }
);
      }
  }


export type botPluginResetPluginSettingsResponse200 = {
  data: ApiEnvelopeBotPluginSaveSettingsResponse
  status: 200
}

export type botPluginResetPluginSettingsResponse400 = {
  data: ApiEnvelopeBotPluginSaveSettingsResponse
  status: 400
}

export type botPluginResetPluginSettingsResponse401 = {
  data: ApiEnvelopeBotPluginSaveSettingsResponse
  status: 401
}

export type botPluginResetPluginSettingsResponse403 = {
  data: ApiEnvelopeBotPluginSaveSettingsResponse
  status: 403
}

export type botPluginResetPluginSettingsResponse404 = {
  data: ApiEnvelopeBotPluginSaveSettingsResponse
  status: 404
}

export type botPluginResetPluginSettingsResponseSuccess = (botPluginResetPluginSettingsResponse200) & {
  headers: Headers;
};
export type botPluginResetPluginSettingsResponseError = (botPluginResetPluginSettingsResponse400 | botPluginResetPluginSettingsResponse401 | botPluginResetPluginSettingsResponse403 | botPluginResetPluginSettingsResponse404) & {
  headers: Headers;
};

export type botPluginResetPluginSettingsResponse = (botPluginResetPluginSettingsResponseSuccess | botPluginResetPluginSettingsResponseError)

export const getBotPluginResetPluginSettingsUrl = (botId: string,
    pluginName: string,) => {




  return `/api/botengine/${botId}/settings/${pluginName}/reset`
}

export const useBotPluginResetPluginSettingsHook = (): (botId: string,
    pluginName: string, options?: RequestInit) => Promise<botPluginResetPluginSettingsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    pluginName: string, options?: RequestInit) => {

        return customFetcher(getBotPluginResetPluginSettingsUrl(botId,pluginName),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


